import WebsiteBehaviors from "../website-behaviors/index.js";

class Dropbox extends WebsiteBehaviors {
	identifier() {
		return "Dropbox";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "www.dropbox.com");
	}

	styles() {
		// We prevent dropbox's own highlighting widget from showing up in their pdf viewer

		// language=CSS
		return `
			.sc-annotation-mouse-tooltip {
				display: none;
			}
			.sc-add-annotation-highlight-button {
				display: none;
			}
		`;
	}
}

export default Dropbox;
